export default "__VITE_ASSET__CptGtAK1__"